import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { ConfigService } from './config.service';
import { FsContactAttachmentStatusEnum } from '../shared/enums/fs-contact-attachment-status.enum';
import { Result } from '../shared/models/result.model';

@Injectable({
  providedIn: 'root'
})
export class FsContactAttachmentService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  public getReviewableAttachments(profileId: number): Observable<Result> {
    return this.httpClient.get<Result>(
      `${this.configService.apiUrl}/v1.0/fs-contact-attachments?profileId=${profileId}&statusIds=${FsContactAttachmentStatusEnum.ReadyForReview}`).pipe(
        catchError(error => {
          console.log(error);
          return EMPTY;
        }),
        shareReplay()
      );
  }

  public getDownloadUrl(profileId: number, obsAssessmentId: number, attachmentId: number): Observable<Result> {
    return this.httpClient.get<Result>(
      `${this.configService.apiUrl}/v1.0/fs-contact-attachments/${attachmentId}/download-url?profileId=${profileId}&obsAssessmentId=${obsAssessmentId}`);
  }
}
